import React from 'react';
import { Link } from 'react-router-dom';
import './VendorProfileButton.css';

const VendorProfileButton = ({ to }) => {
    if (!to) return null;

    return (
        <Link
            to={to}
            className="vendor-profile-shop-btn"
            title="View Vendor Profile"
            aria-label="View Vendor Profile"
            onClick={(event) => event.stopPropagation()}
        >
            <i className="bi bi-shop" aria-hidden="true"></i>
        </Link>
    );
};

export default VendorProfileButton;
